import { render, staticRenderFns } from "./32.vue?vue&type=template&id=4896065e&scoped=true&"
import script from "./32.vue?vue&type=script&lang=js&"
export * from "./32.vue?vue&type=script&lang=js&"
import style0 from "./32.vue?vue&type=style&index=0&id=4896065e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4896065e",
  null
  
)

export default component.exports